import { $, $$ } from '../helpers/selectors';

const SELECTOR = '.wysiwyg';

class Wysiwyg {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    if ($$('ul', $(SELECTOR))) {
      const wysiwygUlList = $$('ul', $(SELECTOR));
      wysiwygUlList.forEach(list => {
        const listItems = $$('li', list);
        list.setAttribute('role', 'list');
        listItems.forEach(listItem => {
          listItem.setAttribute('role', 'listitem');
        });
      });
    }
  }
}

export default Wysiwyg;
